// A build and compile-time type-safe filter for removing nulls and undefineds
const notEmpty = <TargetType>(
  value: TargetType | null | undefined
): value is TargetType => {
  if (value === null || value === undefined) return false

  // Dummy assignment triggers error at compile time in case of type-mismatch.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const compileTimeDummyVar: TargetType = value
  return true
}

export default notEmpty
